import styled from 'styled-components'

import { theme } from '../../constants'

export const Page = styled.div`
  display: grid;
  gap: ${theme.spacing[6]};
`

export const EmptyState = styled.div`
  display: grid;
  gap: ${theme.spacing[4]};
  padding: ${theme.spacing[6]} ${theme.spacing[4]};
  border: ${theme.semanticColors.border.default};
  border-radius: ${theme.radii.large};
  background: ${theme.semanticColors.background.surface};
`

export const ErrorState = styled(EmptyState)`
  border-color: ${theme.colors.error};
`
